import * as types from "./downloaderActionType";
import download from "downloadjs";

export default function downloaderReducer(state = {files: [], errorDownloads: [], successDownloads: []}, action) {

  switch (action.type) {
    case types.DOWNLOAD_FILE: {
      
      state.files = [...state.files, {"identifier": action.fileInfo, "path": action.path, "showGeneratingToast": action.showGeneratingToast}];
      
      return state;
    }
    case types.DOWNLOAD_FILE_SUCCESS: {
      
      let fileData = action.payload.data.result;
      
      if(fileData.type == "application/xml" || typeof fileData.fileContent == "undefined"){
        /**
         * Only used for s3 links.
         */
        
        let fullPath = action.payload.data.path;
        let fileName = fullPath.split('/').pop().split('?')[0]; // File names are between / and ? characters for s3 links.
        download(fileData, decodeURI(fileName));
      }
      else{
        download(atob(fileData.fileContent), decodeURI(fileData.fileName));
      }

      return {...state, successDownloads: [...state.successDownloads, {"path": action.payload.data.path, "extraData": action.payload.data.result.extraData}]};
      
    }
    case types.DOWNLOAD_FILE_FAILURE: {      
      return {...state, errorDownloads: [...state.errorDownloads,{"path": action.payload.error.path, "message": action.payload.message, "serverError": action.payload.error,
       "extraData": action.payload.error.extraData}] };
    }

    case types.CLEAR_ERROR_DOWNLOAD:{
      return {...state, errorDownloads: state.errorDownloads.filter(download => download.path != action.path)};
    }

    case types.CLEAR_SUCCESS_DOWNLOAD:{
      return {...state, successDownloads: state.successDownloads.filter(download => download.path != action.path)};
    }

    case types.CLEAR_ONGOING_DOWNLOAD:{
      return {...state, files: state.files.filter(download => download.path != action.path)};
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/downloader/downloaderReducer.js